import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { IconMenu, MenuItem } from 'react-toolbox/lib/menu'
import T from 'i18n-react'
import showOnAnyRoles from 'containers/Role/Show/AnyGlobalRoles'
import { GLOBAL_ROLES, PROJECT_ROLES } from 'containers/Role/constants'
import { mapProps, compose } from 'recompose'
import styles from './styles.scss'

const showToTeam = compose(
  mapProps((props) => ({
    ...props,
    roles: [ ...Object.values(PROJECT_ROLES), GLOBAL_ROLES.ADMIN_ACCESS ]
  })),
  showOnAnyRoles
)

const showToTeamOrClient = compose(
  mapProps((props) => ({
    ...props,
    roles: [
      ...Object.values(PROJECT_ROLES),
      GLOBAL_ROLES.CLIENT_ACCESS,
      GLOBAL_ROLES.ADMIN_ACCESS
    ]
  })),
  showOnAnyRoles
)

const RenameItem = showToTeamOrClient(MenuItem)
const RenameDescriptionItem = showToTeamOrClient(MenuItem)
const InternalItem = showToTeam(MenuItem)
const RemoveItem = showToTeam(MenuItem)

const FileMenu = (props) => {
  const {
    internal,
    onInternal,
    onDownload,
    onRename,
    onRenameDescription,
    onRemove
  } = props

  return (
    <IconMenu
      icon='more_vert'
      position='auto'
      menuRipple
    >
      <MenuItem
        onClick={onDownload}
        icon='get_app'
        caption='Download'
      />
      <RenameItem
        onClick={onRename}
        icon='edit'
        caption='Change File Name'
      />
      <RenameDescriptionItem
        onClick={onRenameDescription}
        icon='edit_note'
        caption='Change Description'
      />
      <InternalItem
        onClick={onInternal}
        icon={internal ? 'visibility' : 'visibility_off'}
        caption={internal ? 'Mark External': 'Mark Internal'}
      />
      <RemoveItem
        onClick={onRemove}
        icon='delete'
        caption='Delete'
      />
    </IconMenu>
  )
}


const withStyle = CSSModules(styles)
export default withStyle(FileMenu)
